import { Converter } from '../types/converter';

export const areaConverter: Converter = {
  id: 'area',
  name: 'Area Converter',
  icon: 'Square',
  categories: ['common', 'engineering'],
  units: [
    // SI units
    { name: 'Square meter', symbol: 'm²', factor: 1 },
    { name: 'Square kilometer', symbol: 'km²', factor: 1e6 },
    { name: 'Square centimeter', symbol: 'cm²', factor: 0.0001 },
    { name: 'Square millimeter', symbol: 'mm²', factor: 1e-6 },
    { name: 'Square micrometer', symbol: 'µm²', factor: 1e-12 },
    { name: 'Square nanometer', symbol: 'nm²', factor: 1e-18 },
    { name: 'Square hectometer', symbol: 'hm²', factor: 10000 },
    { name: 'Square dekameter', symbol: 'dam²', factor: 100 },
    { name: 'Square decimeter', symbol: 'dm²', factor: 0.01 },
    
    // Common land units
    { name: 'Hectare', symbol: 'ha', factor: 10000 },
    { name: 'Are', symbol: 'a', factor: 100 },
    { name: 'Acre', symbol: 'ac', factor: 4046.8564224 },
    { name: 'Acre (US survey)', symbol: 'ac (US)', factor: 4046.872627 },
    { name: 'Square mile', symbol: 'mi²', factor: 2589988.110336 },
    { name: 'Square mile (US survey)', symbol: 'mi² (US)', factor: 2589998.470305 },
    { name: 'Square yard', symbol: 'yd²', factor: 0.83612736 },
    { name: 'Square foot', symbol: 'ft²', factor: 0.09290304 },
    { name: 'Square foot (US survey)', symbol: 'ft² (US)', factor: 0.092903411613 },
    { name: 'Square inch', symbol: 'in²', factor: 0.00064516 },
    
    // Specialized units
    { name: 'Barn', symbol: 'b', factor: 1e-28 },
    { name: 'Circular inch', symbol: 'circ in', factor: 0.000506707479 },
    { name: 'Township', symbol: 'twp', factor: 93239571.972 },
    { name: 'Section', symbol: 'sec', factor: 2589988.110336 },
    { name: 'Rood', symbol: 'rood', factor: 1011.7141056 },
    { name: 'Square chain', symbol: 'ch²', factor: 404.6872627 },
    { name: 'Square rod', symbol: 'rd²', factor: 25.29285264 },
    { name: 'Square rod (US survey)', symbol: 'rd² (US)', factor: 25.29295532 },
    { name: 'Square perch', symbol: 'perch²', factor: 25.29285264 },
    { name: 'Square pole', symbol: 'pole²', factor: 25.29285264 },
    { name: 'Square mil', symbol: 'mil²', factor: 6.4516e-10 },
    { name: 'Circular mil', symbol: 'cmil', factor: 5.067075e-10 },
    
    // Historical and regional units
    { name: 'Homestead', symbol: 'homestead', factor: 647497.027584 },
    { name: 'Sabin', symbol: 'sabin', factor: 0.09290304 },
    { name: 'Arpent', symbol: 'arpent', factor: 3418.89 },
    { name: 'Cuerda', symbol: 'cuerda', factor: 3930.395625 },
    { name: 'Plaza', symbol: 'plaza', factor: 6400 },
    { name: 'Varas castellanas cuad', symbol: 'varas²', factor: 0.698737 },
    { name: 'Varas conuqueras cuad', symbol: 'varas con²', factor: 0.698737 },
    
    // Scientific unit
    { name: 'Electron cross section', symbol: 'σe', factor: 6.6524587321e-29 }
  ]
};
